const INITIAL_OPEN_STATE_STORAGE_KEY = "has_seen_need_help_initial_open_state";
const ACTIVE_CLASS = "is-active";
const MINIMIZE_DELAY = 5000;
const LEAVE_DELAY = 1000;
const SCROLL_DISMISS_TOLERANCE_PX = 300;

/** Root component element. */
const needHelp: HTMLElement | null = document.querySelector(".js-need-help");

/** Set active state. */
const toggleActive = (needHelp: HTMLElement, isActive: boolean = false) =>
  needHelp.classList.toggle(ACTIVE_CLASS, isActive);

/** Potential timeout for dismissal. */
let interactionTimeout: null | NodeJS.Timeout = null;

/**
 * Adjust bottom inset positioning to not collide with footer.
 */
export const pushBottomTick = () => {
  const scrollY = window.scrollY;

  const footer = <HTMLElement | null>document.querySelector(".js-footer");

  if (!(footer instanceof HTMLElement)) {
    return;
  }

  const offset =
    scrollY + window.innerHeight >= footer.offsetTop
      ? scrollY + window.innerHeight - footer.offsetTop
      : 0;

  if (needHelp instanceof HTMLElement) {
    needHelp.style.bottom = `${offset}px`;
  }
};

if (needHelp instanceof HTMLElement) {
  /**
   * Open initial state upon page load. Once per browser session.
   */
  if (window.sessionStorage.getItem(INITIAL_OPEN_STATE_STORAGE_KEY) === null) {
    toggleActive(needHelp, true);
    setTimeout(() => toggleActive(needHelp, false), MINIMIZE_DELAY);
    window.sessionStorage.setItem(
      INITIAL_OPEN_STATE_STORAGE_KEY,
      new Date().toString()
    );
  }

  /**
   * Destroy dismiss intent and open upon mouse enter.
   */
  needHelp.addEventListener("mouseenter", () => {
    if (interactionTimeout) {
      clearTimeout(interactionTimeout);
    }

    toggleActive(needHelp, true);
  });

  /**
   * Create intent to dismiss after mouse leaves.
   */
  needHelp.addEventListener("mouseleave", () => {
    interactionTimeout = setTimeout(
      () => toggleActive(needHelp, false),
      LEAVE_DELAY
    );
  });

  window.addEventListener("load", pushBottomTick);
  window.addEventListener("click", pushBottomTick);
  window.addEventListener("resize", pushBottomTick);

  /**
   * Scroll based handlers.
   */
  let ticking = false;

  window.addEventListener("scroll", () => {
    const scrollY = window.scrollY;

    pushBottomTick();

    if (!ticking) {
      window.requestAnimationFrame(() => {
        /**
         * Dismiss once user scrolls past a certain threshold.
         */
        if (scrollY >= SCROLL_DISMISS_TOLERANCE_PX) {
          toggleActive(needHelp, false);
        }

        ticking = false;
      });

      ticking = true;
    }
  });
}
